import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	default: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.checkboxes.default-value.default',
		defaultMessage: 'Preselected',
		description: 'Label. Displayed if option selected as default value.',
	},
	disabledTooltipCheck: {
		id: 'issue-type-page.field-associated.field-configuration.checkboxes.default-value.disabled-tooltip-check',
		defaultMessage: 'You can’t preselect this option',
		description: "Tooltip shown when a user can't preselect an option",
	},
	disabledTooltipUncheck: {
		id: 'issue-type-page.field-associated.field-configuration.checkboxes.default-value.disabled-tooltip-uncheck',
		defaultMessage: 'You can’t clear this preselection',
		description:
			"Tooltip shown when a user can't modify the default value of an option that has been preselected",
	},
	tooltipCheck: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.checkboxes.default-value.tooltip-check',
		defaultMessage: 'Preselect',
		description:
			'Displayed when user hovers over an unchecked checkbox (which allows to mark an option as selected by default)',
	},
	tooltipUncheck: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.checkboxes.default-value.tooltip-uncheck',
		defaultMessage: 'Clear preselection',
		description:
			'Displayed when user hovers over a selected checkbox (which allows to uncheck an option so it wont be preselected by default)',
	},
	checkboxLabel: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.checkboxes.default-value.checkbox-label',
		defaultMessage: 'Checkbox for option {option}',
		description: 'Label for a checkbox associated with the given option',
	},
});
